import React from 'react';
import {FriendMenu} from "./FriendMenu.js";

export class FriendProfile extends React.Component {
  constructor(props) {
    super(props);  // Call super(props)
    this.state = { profile: this.props.profile }; // Correct state initialization
    this.handleClickInner = this.handleClickInner.bind(this); // Bind this
 
  }

  handleClickInner(event) {
    event.stopPropagation();
  }

  render() {
    // Check if profile data exists before rendering to avoid errors
    if (!this.state.profile) {
      return <div>Loading...</div>; // Or a suitable loading indicator
    }

    const { imagesrcs, name } = this.state.profile; // Destructure for cleaner code

    return (
        
      <div onClick={this.props.close} class="p-[20%]"> {/* Enclose everything in a single div */}
        <div class="lg-max:mt-6 w-[100%]"  onClick={this.handleClickInner} >
            <div class="p-[15px] relative flex flex-col h-full min-w-0 break-words bg-white border-0 shadow-xl dark:bg-slate-850 dark:shadow-dark-xl rounded-2xl bg-clip-border">
              <div class="pb-0 mb-0 border-b-0 rounded-t-2xl">
              <h6 class="block antialiased tracking-normal font-sans text-base font-semibold leading-relaxed text-blue-gray-900">Connection</h6>
              </div>
              <div class="flex-auto p-4">
                <ul class="flex flex-col pl-0 mb-0 rounded-lg">
                  <li class="relative flex items-center px-0 py-2 mb-2 border-0 rounded-t-lg ">
                    <div class="inline-flex items-center justify-center w-12 h-12 mr-4 text-base text-white transition-all duration-200 ease-in-out rounded-xl">
                      <img src="../../../assets/img/kal-visuals-square.jpg" alt="kal" class="w-full shadow-2xl rounded-xl"/>
                    </div>
                    <div class="flex flex-col items-start justify-center">
                      <h6 class="mb-0 text-sm leading-normal dark:text-white">Sophie B.</h6>
                      <p class="mb-0 text-xs leading-tight dark:text-white dark:opacity-60">Hi! I need more information..</p>
                    </div>
                    <a class="inline-block py-3 pl-0 pr-4 mb-0 ml-auto text-sm font-bold leading-normal text-center text-blue-500 align-middle transition-all ease-in bg-transparent border-0 rounded-lg shadow-none cursor-pointer hover:-translate-y-px hover:active:-translate-y-px active:opacity-85 hover:text-blue-800 hover:shadow-none active:scale-100" href="javascript:;">Reply</a>
                  </li>
                  <li class="relative flex items-center px-0 py-2 mb-2 border-0 border-t-0 ">
                    <div class="inline-flex items-center justify-center w-12 h-12 mr-4 text-base text-white transition-all duration-200 ease-in-out rounded-xl">
                      <img src="../../../assets/img/marie.jpg" alt="kal" class="w-full shadow-2xl rounded-xl"/>
                    </div>
                    <div class="flex flex-col items-start justify-center">
                      <h6 class="mb-0 text-sm leading-normal dark:text-white">Anne Marie</h6>
                      <p class="mb-0 text-xs leading-tight dark:text-white dark:opacity-60">Awesome work, can you..</p>
                    </div>
                    <a class="inline-block py-3 pl-0 pr-4 mb-0 ml-auto text-sm font-bold leading-normal text-center text-blue-500 align-middle transition-all ease-in bg-transparent border-0 rounded-lg shadow-none cursor-pointer hover:-translate-y-px hover:active:-translate-y-px active:opacity-85 hover:text-blue-800 hover:shadow-none active:scale-100" href="javascript:;">Reply</a>
                  </li>
                  <li class="relative flex items-center px-0 py-2 mb-2 border-0 border-t-0 ">
                    <div class="inline-flex items-center justify-center w-12 h-12 mr-4 text-base text-white transition-all duration-200 ease-in-out rounded-xl">
                      <img src="../../../assets/img/ivana-square.jpg" alt="kal" class="w-full shadow-2xl rounded-xl"/>
                    </div>
                    <div class="flex flex-col items-start justify-center">
                      <h6 class="mb-0 text-sm leading-normal dark:text-white">Ivanna</h6>
                      <p class="mb-0 text-xs leading-tight dark:text-white dark:opacity-60">About files I can..</p>
                    </div>
                    <a class="inline-block py-3 pl-0 pr-4 mb-0 ml-auto text-sm font-bold leading-normal text-center text-blue-500 align-middle transition-all ease-in bg-transparent border-0 rounded-lg shadow-none cursor-pointer hover:-translate-y-px hover:active:-translate-y-px active:opacity-85 hover:text-blue-800 hover:shadow-none active:scale-100" href="javascript:;">Reply</a>
                  </li>
                  <li class="relative flex items-center px-0 py-2 mb-2 border-0 border-t-0 ">
                    <div class="inline-flex items-center justify-center w-12 h-12 mr-4 text-base text-white transition-all duration-200 ease-in-out rounded-xl">
                      <img src="../../../assets/img/team-4.jpg" alt="kal" class="w-full shadow-2xl rounded-xl"/>
                    </div>
                    <div class="flex flex-col items-start justify-center">
                      <h6 class="mb-0 text-sm leading-normal dark:text-white">Peterson</h6>
                      <p class="mb-0 text-xs leading-tight dark:text-white dark:opacity-60">Have a great afternoon..</p>
                    </div>
                    <a class="inline-block py-3 pl-0 pr-4 mb-0 ml-auto text-sm font-bold leading-normal text-center text-blue-500 align-middle transition-all ease-in bg-transparent border-0 rounded-lg shadow-none cursor-pointer hover:-translate-y-px hover:active:-translate-y-px active:opacity-85 hover:text-blue-800 hover:shadow-none active:scale-100" href="javascript:;">Reply</a>
                  </li>
                  <li class="relative flex items-center px-0 py-2 border-0 border-t-0 rounded-b-lg ">
                    <div class="inline-flex items-center justify-center w-12 h-12 mr-4 text-base text-white transition-all duration-200 ease-in-out rounded-xl">
                      <img src="../../../assets/img/team-3.jpg" alt="kal" class="w-full shadow-2xl rounded-xl"/>
                    </div>
                    <div class="flex flex-col items-start justify-center">
                      <h6 class="mb-0 text-sm leading-normal dark:text-white">Nick Daniel</h6>
                      <p class="mb-0 text-xs leading-tight dark:text-white dark:opacity-60">Hi! I need more information..</p>
                    </div>
                    <a class="inline-block py-3 pl-0 pr-4 mb-0 ml-auto text-sm font-bold leading-normal text-center text-blue-500 align-middle transition-all ease-in bg-transparent border-0 rounded-lg shadow-none cursor-pointer hover:-translate-y-px hover:active:-translate-y-px active:opacity-85 hover:text-blue-800 hover:shadow-none active:scale-100" href="javascript:;">Reply</a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        <img src={imagesrcs} alt={name + "'s profile picture"} /> {/* Add alt text for accessibility */}
        <div>{name}</div>
        <FriendMenu profile={this.state.profile} /> {/* Pass data as prop */}
      </div>
    );
  }
}
